export const PROVIDERS = {
  SALESFORCE: 'salesforce',
  OMNIHIT: 'omnihit',
  NONE: 'none',
} as const;

export type ProviderId = (typeof PROVIDERS)[keyof typeof PROVIDERS];

type BaseProvider = {
  id: ProviderId;
  initialize: () => Promise<void>;
  authenticate: () => Promise<void>;
  getAuthHeaders: () => Promise<Record<string, string>>;
  getUserInfo: () => Promise<UserInfo>;
  openWidget: () => void;
};

export type UserInfo = {
  email: string;
};

export type LeadPhoneBook = Record<string, string>;

export type SalesforceProvider = BaseProvider & {
  id: typeof PROVIDERS.SALESFORCE;
  openCase: (caseId: string) => void;
  openLead: (leadId: string, created: boolean) => void;
  logCall: (details: { contactId: string }) => Promise<void>;
  enableClickToDial: (listener: (number: string) => void) => void;
  getUserInfo: () => Promise<UserInfo>;
  getLeadPhoneBook: () => Promise<LeadPhoneBook>;
};

export type OmnihitProvider = BaseProvider & {
  id: typeof PROVIDERS.OMNIHIT;
  sendExtensionReadyNotification: () => void;
  setCallListener: (listener: (number: string) => void) => void;
  openTicket: (ticketId: string) => Promise<void>;
};

export type NoneProvider = BaseProvider & {
  id: typeof PROVIDERS.NONE;
};

export type IProvider = NoneProvider | SalesforceProvider | OmnihitProvider;
